export const GRID_MESSAGE_KEYS_OVERRIDES: Record<string, string> = {
  "kendo.grid.lock": "freeze_column",
  "kendo.grid.unlock": "unfreeze_column",
} as const;
